import { all, put, takeLatest } from "redux-saga/effects";

import store from "../../store/store";
import {
  hideLoader,
  showLoader,
} from "../../component-lib/Molecules/loader/LoaderSlice";
import { eventEHRCustomToastMessage } from "../../component-lib/Atoms/custom-toast-message/EventEHRCustomToastMessage";
import {
  componentKey,
  setCloseAddContactDialog,
  setContactDirectoryData,
} from "./contactDirectorySlice";
import ContactDirectoryService from "../../services/ContactDirectoryService";

export const {
  postContactDirectoryData,
  getContactDirectoryList,
  updateContactData,
  deleteContact,
} = {
  postContactDirectoryData: (payload) => {
    return {
      type: "PATIENT/POST_CONTACT_DIRECTORY_DATA",
      payload,
    };
  },
  getContactDirectoryList: (payload) => {
    return {
      type: "PATIENT/GET_CONTACT_DIRECTORY_LIST",
      payload,
    };
  },
  updateContactData: (payload) => {
    return {
      type: "PATIENT/UPDATE_CONTACT_DATA",
      payload,
    };
  },
  deleteContact: (payload) => {
    return {
      type: "PATIENT/DELETE_CONTACT",
      payload,
    };
  },
};

// POST TASK DATA ASYNC
function* postContactDirectoryDataAsync(action) {
  // const { apiPayload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield ContactDirectoryService.postContactDirectoryData(
      action?.payload?.apiPayload
    );

    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddContactDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddContactDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// GET TASK DATA ASYNC
function* getContactDirectoryListAsync(action) {
  try {
    yield put(showLoader());
    const response = yield ContactDirectoryService.getContactDirectoryList(
      action?.payload
    );
    const { status } = response;
    if (status) {
      yield put(setContactDirectoryData(response?.data));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setContactDirectoryData({}));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* updateContactDataAsync(action) {
  // const { apiPayload } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield ContactDirectoryService.updateContactData(
      action?.payload?.id,
      action?.payload?.apiPayload
    );

    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
      yield put(setCloseAddContactDialog(true));
    }
  } catch (error) {
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });
    yield put(setCloseAddContactDialog(false));
    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

// DELETE CONTACT ASYNC
function* deleteContactAsync(action) {
  const { contactId, comesFrom } = action?.payload;
  try {
    yield put(showLoader());
    const response = yield ContactDirectoryService.deleteContact(contactId);
    const { status } = response;
    if (status) {
      const { data, message } = response?.data;
      yield put(setCloseAddContactDialog(true));
      eventEHRCustomToastMessage({
        title: `${message}`,
        status: "success",
      });
    }
  } catch (error) {
    yield put(setCloseAddContactDialog(false));
    eventEHRCustomToastMessage({
      title: `${error?.response?.data?.message}`,
      status: "error",
    });

    console.log("err: ", error);
  } finally {
    yield put(hideLoader());
  }
}

function* rootSaga() {
  yield all([
    takeLatest(postContactDirectoryData().type, postContactDirectoryDataAsync),
  ]);
  yield all([
    takeLatest(getContactDirectoryList().type, getContactDirectoryListAsync),
  ]);
  yield all([takeLatest(updateContactData().type, updateContactDataAsync)]);
  yield all([takeLatest(deleteContact().type, deleteContactAsync)]);

}

store.sagaManager.addSaga(componentKey, rootSaga);
